import { organizationPaginatedListQuery, userListQuery } from '../../../data/queries.ts';
import ensureQueriesData from '../../../utils/ensureQueriesData.ts';

export const organizationListLoader = () =>
    ensureQueriesData({
        // TODO: preload with wrong data just adds more queries
        // organizations: organizationPaginatedListQuery(undefined, { page: 1, pageSize: 30 }),
        // users: userListQuery(),
    });
